import React from 'react'

interface PickingRouteReviewErrorProps {
  error: string | undefined
}

export const PickingRouteReviewError: React.FC<PickingRouteReviewErrorProps> =
  ({ error }) => {
    return <caption style={{ minWidth: '100px' }}>{error}</caption>
  }
